import { Field, Form, Formik, useFormikContext } from "formik";
import { observer } from "mobx-react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import {
  floatRegex,
  integerRegex,
  inValidCharacterForStoreName,
  stringRegex,
} from "../../../../../constants/constants";
import LoaderButton from "../../../../../shared-components/button/loader-button";
import FormikDateFieldMUI from "../../../../../shared-components/FormikFormHandlers/FormikDateFieldMUI";
import FormikFormInputForRegexCheck from "../../../../../shared-components/FormikFormHandlers/FormikFormInputForRegexCheck";
import Label from "../../../../../shared-components/label/label";
import { motivationInitialState } from "../../../../../core/initialState/master-settings-state";
import { useStore } from "../../../../../contexts/store-provider";
import FormikFormInput from "../../../../../shared-components/FormikFormHandlers/FormikFormInput";
import * as Yup from "yup";
interface IProps {
  id: number;
  initialValues: any;
  submitHandler: (data: any) => void;
  addUpdateInProgress: boolean;
  actionSuccess: boolean;
  onCancelEdit: () => void;
}

const validationSchema = Yup.object().shape({
  MotivationName: Yup.string()
    // .matches(stringEnJpRegex, "motivation_name_invalid_format")
    .required("field_required"),
  Description: Yup.string().max(300, "max_300_characters"),
});

const AddMotivationSettingsForm: React.FC<IProps> = (props: IProps) => {
  const {
    submitHandler,
    addUpdateInProgress,
    actionSuccess,
    initialValues,
    id,
    onCancelEdit,
  } = props;
  const { masterManagementStore } = useStore();
  const { addUpdateMotivationSettingState } = masterManagementStore;
  let resetPresForm = () => {};
  const [initialValue, setInitialValue] = useState<any>({
    ...initialValues,
  });
  const FormObserver: React.FC = () => {
    const { values } = useFormikContext<any>();
    return null;
  };

  /**
   * This functional component stores the reset form function in the resetPresentForm variable
   */
  const ResettingForm = () => {
    const { resetForm } = useFormikContext();
    resetPresForm = resetForm;
    return null;
  };

  useEffect(() => {
    if (addUpdateMotivationSettingState) {
      setInitialValue({ ...motivationInitialState });
      resetPresForm();
    }
  }, [addUpdateMotivationSettingState]);

  useEffect(() => {
    if (actionSuccess) {
      resetPresForm();
      setInitialValue({ ...motivationInitialState });
    }
  }, [actionSuccess]);

  return (
    <>
      <Formik
        initialValues={{ ...initialValues }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={async (values: any) => {
          submitHandler(
            id > 0
              ? { ...values, Id: id }
              : {
                  Description: values.Description,
                  MotivationName: values.MotivationName,
                }
          );
        }}
      >
        {({ values, resetForm }) => (
          <>
            <Form className="setting-form" noValidate>
              <FormObserver />
              <Row className="position-relative">
                <Col sm={5} md={5} lg={5} xl={5}>
                  <Label
                    className="form-label"
                    required={true}
                    label="motivation_name"
                  />
                  <Field
                    className="form-control"
                    aria-label="Default select example"
                    name="MotivationName"
                    placeholder="enter_motivation_name"
                    as={FormikFormInput}
                    invalidcharacter={inValidCharacterForStoreName}
                  />
                </Col>
                <Col sm={5} md={5} lg={5} xl={5}>
                  <Label
                    className="form-label"
                    required={false}
                    label="description"
                  />
                  <Field
                    className="form-control"
                    aria-label="Default select example"
                    name="Description"
                    placeholder="description"
                    as={FormikFormInput}
                    validcharacter={[
                      "・",
                      "／",
                      "－",
                      "～",
                      "＋",
                      "（",
                      "）",
                      "［",
                      "］",
                      "※",
                      "：",
                      "★",
                      "☆",
                      "◎",
                      "○",
                      "●",
                      "◆",
                      "◇",
                      "■",
                      "□",
                      "→",
                      "⇒",
                      "♪",
                      "(",
                      ")",
                      "【",
                      "】",
                      "￥",
                      '"',
                      "＜",
                      "＞",
                      "！",
                      "？",
                      "↓",
                      "↑",
                      "←",
                      "．",
                      '"',
                      "゛",
                      "'",
                      "'",
                      '"',
                      '"',
                      "、",
                      "。",
                      "《",
                      "》",
                      "+",
                      "-",
                      "[",
                      "]",
                      "|",
                      "*",
                      "&",
                      "/",
                      ".",
                      "!",
                      "@",
                      "#",
                      "$",
                      "%",
                      "^",
                      "_",
                      "`",
                      "{",
                      "}",
                      "?",
                      ";",
                      ":",
                      ",",
                      "=",
                      "~",
                      "<",
                      ">",
                    ]}
                  />
                  <p className="small text-muted text-end mt-1">{`${
                    values.Description ? values.Description.length : 0
                  }/300`}</p>
                </Col>
                <Col sm={2} md={2} lg={2} xl={2}>
                  <LoaderButton
                    type="submit"
                    className="label-top-margin "
                    isLoading={addUpdateInProgress}
                    disabled={addUpdateInProgress}
                    text={id > 0 ? "button_update" : "add"}
                  />

                  {id > 0 && (
                    <LoaderButton
                      type="button"
                      className="label-top-margin ms-2"
                      variant="danger"
                      onClick={() => {
                        onCancelEdit();
                        setInitialValue({ ...motivationInitialState });
                        resetPresForm();
                        resetForm({ values: motivationInitialState });
                      }}
                      isLoading={false}
                      disabled={addUpdateInProgress}
                      text="button_cancel"
                    />
                  )}
                </Col>
              </Row>

              <ResettingForm />
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

export default observer(AddMotivationSettingsForm);
